import "../../pageTypes/BasicPage_Player/BasePageDesigner.css";
import React, { useState, useContext } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { pageSelectIconInfo, IPageSelectIcon } from "./pageSelectIconInfo";
import {
  IPageContext,
  PageContext,
  LessonPageActionsContext,
  ILessonPageActionsContext,
} from "../../routes/builderContexts";
import { BASIC_PAGE, FMS_PAGE, QUIZ_PAGE, ThreeD_PAGE, WALK_AROUND, CABIN, AGGREGATION } from "../constants/pageTypes";
import { ReactComponent as ExitIcon } from "../../assets/icons/NewPageSelector/exit-icon-close.svg";
import { isDevelopmentEnvironment } from "../../utils/environment";
import { useLessonData } from "../../contexts/LessonDataProvider";
import useSettingsToggle, { settingType } from "../../hooks/useSettingsToggle";
import { setHsListerIsOpen } from "../../store/actions/actions";
import { AbstractTooltip as Tooltip } from "../ToolTip/ToolTip";
import { getNewPagePlacement } from "./newPagePlacement";
type ModalType = {
  show: boolean;
  onHide: () => void;
  isCpatUser?: boolean;
  setHsListerIsOpen: (val: boolean) => void;
};

const NewPageSelector: React.FC<ModalType> = (props: ModalType) => {
  // const assetContext: IAssetManagementContext = useContext<IAssetManagementContext>(AssetContext)
  const pageContext: IPageContext = useContext<IPageContext>(PageContext);
  const lessonPageActions: ILessonPageActionsContext = useContext<ILessonPageActionsContext>(LessonPageActionsContext);
  const [selectedKey, setSelectedKey]: [number, React.Dispatch<React.SetStateAction<number>>] = useState<number>(-1);
  // let selectedType: string;
  const permissions = useLessonData({ permissions: true });
  const [featuresToRender] = useSettingsToggle({
    cabinPages: settingType.cpatonly,
  });
  const { cabinPages } = featuresToRender;
  const hasModel = (pageType: string) => {
    switch (pageType) {
      case FMS_PAGE:
        return !(lessonPageActions.fmsCdus.length === 0);
      case ThreeD_PAGE:
        return !(lessonPageActions.threeDModels.length === 0);
      case WALK_AROUND:
        return !(lessonPageActions.walkaroundModels.length === 0);
      case CABIN:
        return !(lessonPageActions.cabinModels.length === 0) && cabinPages;
      default:
        return true;
    }
  };

  const cpatRestricted = (pageType: string) => {
    if (props.isCpatUser) {
      return false;
    }

    switch (pageType) {
      case WALK_AROUND:
      case CABIN:
        return true;
      default:
        return false;
    }
  };

  const pageRestriction = (pageType: string) => {
    if (pageType === "Aggregation") {
      return true;
    }
    // these page types are dev-only
    const devOnlyPageTypes = [FMS_PAGE, ThreeD_PAGE, WALK_AROUND, CABIN];
    if (devOnlyPageTypes.includes(pageType) && !isDevelopmentEnvironment()) {
      return false;
    }
    return hasModel(pageType) && permissions.canCreate(pageType) && permissions.canEdit(pageType);
  };

  const displayIcons = () => {
    return pageSelectIconInfo
      .filter((el: IPageSelectIcon, index: number) => {
        // let check = false;
        // if (el.caption === '3D Page' && lessonPageActions.threeDModels.length === 0) check = true;
        // if (el.caption === 'FMS Page' && lessonPageActions.fmsCdus.length === 0 ) check = true;
        // if (el.pageType === 'Walkaround' && (props.isCpatUser === false || lessonPageActions.walkaroundModels.length === 0) ) check = true;
        // return !check
        return pageRestriction(el.pageType);
      })
      .map((pageType: IPageSelectIcon, key: number) => {
        return (
          <div className={`page-type-change-icon-container` + ` ${key === selectedKey ? "selected" : ""}`} key={key}>
            <figure onClick={() => handleIconClick(pageType.pageType, key)} data-tooltip-id={pageType.caption}>
              <Tooltip id={pageType.caption} />
              {pageType.icon && <pageType.icon />}
              <figcaption>
                <small>{pageType.caption}</small>
              </figcaption>
            </figure>
          </div>
        );
      });
  };

  const handleIconClick = async (pageType: string, key: number) => {
    const pageName = providePageName(pageType);
    const pagePlacement = getNewPagePlacement(
      pageContext.currentlyDisplayedPageIndex,
      pageContext.currentAggregationOrder,
    );

    if (pageName === "Cockpit Procedures" && !lessonPageActions.proceduresObject.assetVersionId) {
      props.onHide();
      pageContext.setProceduresSelectorBoolean(true);
      setSelectedKey(key);
    } else if (pageName === "Base") {
      setSelectedKey(key);
      props.onHide();
      try {
        await pageContext.addNewPageAndDisplay(pagePlacement, pageType, pageName, undefined, undefined, "freeForm");
      } catch (e) {
        console.error("Failed to add page:", e);
      }
    } else if (pageName === "FMS") {
      props.onHide();
      lessonPageActions.showFMSSelector();
    } else if (pageName === "Walkaround" && !lessonPageActions.currentWalkAroundObject.assetVersionId) {
      props.onHide();
      lessonPageActions.setWalkaroundSelectorShowing(true);
    } else if (pageName === "Cabin" && !lessonPageActions.currentCabinObject.assetVersionId) {
      props.onHide();
      lessonPageActions.setCabinSelectorShowing(true);
    } else if (pageName === "Micro-Lesson") {
      lessonPageActions.showMicroLessonModal();
      props.onHide();
    } else {
      setSelectedKey(key);
      if (pageType === "Cabin") {
        props.setHsListerIsOpen(true);
      }
      props.onHide();
      try {
        await pageContext.addNewPageAndDisplay(pagePlacement, pageType, pageName);
      } catch (e) {
        console.error("Failed to add page:", e);
      }
    }
  };

  // const handleSelectClick = (): void => {
  //   const pageName = providePageName();
  //   const pagePlacement: number = pageContext.currentlyDisplayedPageIndex + 1;
  //
  //   if(pageName === 'ThreeDModel' && !lessonPageActions.proceduresObject.assetVersionId){
  //     props.onHide();
  //     pageContext.setProceduresSelectorBoolean(true);
  //   }
  //   else{
  //     pageContext.addNewPageAndDisplay(pagePlacement, selectedType, pageName);
  //     props.onHide();
  //   }

  // }

  const providePageName = (type: string) => {
    switch (type) {
      case BASIC_PAGE:
        return "Base";

      case FMS_PAGE:
        return "FMS";

      case QUIZ_PAGE:
        return "Quiz";

      case ThreeD_PAGE:
        return "Cockpit Procedures";

      case WALK_AROUND:
        return "Walkaround";

      case CABIN:
        return "Cabin";

      case AGGREGATION:
        return "Micro-Lesson";

      default:
        throw new Error("NO PAGES MATCHING THAT TYPE");
    }
  };

  return (
    <Modal show={props.show} onHide={props.onHide} dialogClassName="basic-page-modal-content-newPages">
      <Modal.Header>
        <div className="modal-header-newPage">
          <h2>Select a Page Type</h2>
          <ExitIcon
            onClick={() => {
              props.onHide();
            }}
          />
        </div>
      </Modal.Header>
      <Modal.Body className="page-type-change-modal-body">
        {"canCreate" in permissions ? displayIcons() : <div>Loading</div>}
      </Modal.Body>
      <Modal.Footer className="button-align">
        <div>
          <button className="layout-select-button main-modal-button" onClick={() => props.onHide()}>
            Cancel
          </button>
        </div>
        <div className="page-type-small">
          <small>This will place a new page after the selected page</small>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

const mapState = (state: any) => {
  return {
    isCpatUser: state.authorizedState.isCpatUser,
  };
};

export default connect(mapState, {
  setHsListerIsOpen,
})(NewPageSelector);
